export const TrustPaths = {
    trustOverview: "trust-overview",
    businessProfiles: "business-profiles",
    brandingAndSpam: "branding-and-spam",
    stirShaken: "stir-shaken",
    cnam: "cnam",
    a2p: "a2p",
} as const;
